import { SET_ENV_CONFIG } from './configuration.actions';

const initialState = {};

export const envConfigReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_ENV_CONFIG:
      return {
        ...state,
        ...payload,
      };
    default:
      return state;
  }
};
